import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useSlate } from "slate-react";

import { RichTextButtonProps, CustomTextKey, CustomElement } from "./types";
import { isAvailable, isMarkActive, isBlockActive, toggleMark, toggleBlock } from "./utils";

export const RichTextButton = ({ active, onMouseDown, title, format, type, icon: Icon }: RichTextButtonProps) => {
    const [t] = useTranslation();
    const editor = useSlate();
    const buttonAvailable = isAvailable(editor, format);

    const buttonActive = buttonAvailable
        ? type === "mark"
            ? isMarkActive(editor, format as CustomTextKey)
            : isBlockActive(editor, format as CustomElement["type"])
        : active;

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        if (type === "mark") {
            toggleMark(editor, format as CustomTextKey);
        } else {
            toggleBlock(editor, format as CustomElement["type"]);
        }
        onMouseDown?.(event);
    };

    return (
        <div
            className={clsx("cursor-pointer rounded p-1", buttonActive && "bg-primary text-white")}
            onMouseDown={buttonAvailable ? handleClick : undefined}
            title={buttonAvailable ? title : `${title} ${t("inputs.RichText.unavailable")}`}
        >
            <Icon className={clsx(!buttonAvailable && "text-color-ant-quaternary")} />
        </div>
    );
};
